import React, { FC, useContext } from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';

import NavWrapper from '../components/wrappers/NavWrapper';
import DigitalLicens from '../pages/digitalLicens/digitalLicensIndex';
import { userContext } from '../utils/userContext';


export interface RouteDigitalLicensProps {
    page: number
}

export class RouteDigitalLicensProps implements RouteDigitalLicensProps {
    constructor(page: number = 0) {
        this.page = page
    }
}


const DigitalLicensRouter: FC = () => {
    let match = useRouteMatch();
    const { hasModule } = useContext(userContext);

    return (
            <NavWrapper pageName="Digitale licenser">
                {!hasModule(match.url) ?
                    <Route component={() => <div>Du har ikke adgang til digitale licenser</div>}/>
                : 
                    <Switch>
                        <Route exact path={match.url} component={DigitalLicens}/>
                        <Route> <div>Siden bliv ikke fundet</div></Route>
                    </Switch>
                }                
            </NavWrapper>
    )
}

export default DigitalLicensRouter;